import all from 'it-all';
export const sortAll = (iterable, sorter) => {
  return async function* () {
    const values = await all(iterable);
    yield* values.sort(sorter);
  }();
};
export const replaceStartWith = (s, r) => {
  const matcher = new RegExp('^' + r);
  return s.replace(matcher, '');
};